<template>
  <div class="title_warehouse">
    <div class="bg-breadcrumb">
      <img :src="img" />
    </div>

    <span>{{ goLang(name) }}</span>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  name: "HomeIndex",
  // metaInfo() {
  //   return {
  //     title: "Warehouse",
  //   };
  // },
  props: {
    name: String,
    img: String,
  },
  components: {
  },
  data() {
    return {
    };
  },
  computed: {
    ...mapGetters("account", ["logged", "accountInfo"]),

  },
  mounted() {
  },
  methods: {
  },
  watch: {

  },
};
</script>

<style lang="css" scoped src="@/static/css/user/list.css">

</style>
